var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('slide-show-display',{attrs:{"project-id":_vm.$route.params.id,"lang":_vm.lang ? _vm.lang : 'Unknown',"show-images":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }